// removed by extract-text-webpack-plugin
module.exports = {"title":"RTDialog__title--3Cthd","body":"RTDialog__body--3jMt_","navigation":"RTDialog__navigation--3few5"};


//////////////////
// WEBPACK FOOTER
// ./src/client/src/theme/RTDialog.scss
// module id = 347
// module chunks = 0